import { ReceiptSummaryResponse } from '../services/trip/tripService';

export interface ReceiptSummaryState {
    isLoading: boolean;
    error: Error | null;
    receiptSummary?: ReceiptSummaryResponse;
}

export enum ReceiptActions {
    RECEIPT_FETCH_BEGIN = 'RECEIPT_FETCH_BEGIN',
    RECEIPT_FETCH_SUCCESS = 'RECEIPT_FETCH_SUCCESS',
    RECEIPT_FETCH_ERROR = 'RECEIPT_FETCH_ERROR',
}

interface FetchReceiptBegin {
    type: typeof ReceiptActions.RECEIPT_FETCH_BEGIN;
}

interface FetchReceiptSuccess {
    type: typeof ReceiptActions.RECEIPT_FETCH_SUCCESS;
    payload: ReceiptSummaryResponse;
}

interface FetchReceiptError {
    type: typeof ReceiptActions.RECEIPT_FETCH_ERROR;
    payload: Error;
}

export type ReceiptActionTypes = FetchReceiptBegin | FetchReceiptSuccess | FetchReceiptError;
